<form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-6" novalidate>
  <div hlmField>
    <label hlmFieldLabel for="partner-signup-email">E-Mail</label>
    <input
      hlmInput
      id="partner-signup-email"
      type="email"
      inputmode="email"
      formControlName="email"
      autocomplete="email"
      placeholder="name@agentur.de"
      class="w-full"
      [attr.aria-invalid]="invalid('email') ? 'true' : null" />
    @if (invalid('email')) {
      <p hlmFieldDescription class="text-destructive">Bitte gib eine gültige E-Mail-Adresse ein</p>
    }
  </div>

  <div hlmField>
    <label hlmFieldLabel for="partner-signup-password">Passwort</label>
    <hlm-input-group class="w-full">
      <input
        hlmInputGroupInput
        id="partner-signup-password"
        [type]="showPassword() ? 'text' : 'password'"
        formControlName="password"
        autocomplete="new-password"
        [attr.aria-invalid]="invalid('password') ? 'true' : null" />
      <hlm-input-group-addon align="inline-end">
        <button
          hlmInputGroupButton
          type="button"
          [attr.aria-label]="showPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
          (click)="showPassword.set(!showPassword())">
          <ng-icon [name]="showPassword() ? 'lucideEyeOff' : 'lucideEye'" />
        </button>
      </hlm-input-group-addon>
    </hlm-input-group>
    <p hlmFieldDescription [class.text-destructive]="invalid('password')">
      Mindestens {{ minLength }} Zeichen.
    </p>
  </div>

  <div hlmField>
    <label hlmFieldLabel for="partner-signup-confirm">Passwort bestätigen</label>
    <hlm-input-group class="w-full">
      <input
        hlmInputGroupInput
        id="partner-signup-confirm"
        [type]="showPassword() ? 'text' : 'password'"
        formControlName="confirm"
        autocomplete="new-password"
        [attr.aria-invalid]="invalid('confirm') ? 'true' : null" />
    </hlm-input-group>
    @if (invalid('confirm')) {
      <p hlmFieldDescription class="text-destructive">
        @if (form.controls.confirm.errors?.['required']) {
          Bitte bestätige dein Passwort.
        } @else {
          Die Passwörter stimmen nicht überein.
        }
      </p>
    }
  </div>

  @if (error()) {
    <div hlmAlert variant="destructive" role="alert">
      <ng-icon name="lucideTriangleAlert" />
      <p hlmAlertTitle>{{ error() }}</p>
      @if (emailTaken()) {
        <p hlmAlertDescription>
          <a routerLink="/partner/login" class="underline underline-offset-4">Zur Anmeldung</a>
        </p>
      }
    </div>
  }

  <button hlmBtn type="submit" class="w-full" [disabled]="loading()" [attr.aria-busy]="loading()">
    @if (loading()) {
      <hlm-spinner />
      Wird gesendet…
    } @else {
      Partner werden
    }
  </button>

  <app-google-button text="signup_with" (credential)="onGoogle($event)" />

  <p class="text-muted-foreground text-center text-sm">
    Mit der Anmeldung akzeptierst du die
    <a
      href="https://schenkwerk.com/partnerprogramm/teilnahmebedingungen"
      target="_blank"
      rel="noopener"
      class="underline underline-offset-4"
      >Teilnahmebedingungen für das Partnerprogramm</a
    >
    und nimmst die
    <a
      href="https://schenkwerk.com/datenschutz"
      target="_blank"
      rel="noopener"
      class="underline underline-offset-4"
      >Datenschutzerklärung</a
    >
    zur Kenntnis.
  </p>
</form>
